export default {"src":"/_next/static/media/logo.358383f1.svg","height":47,"width":219};